import React from "react";
import BaseCarTypeFilter from "./baseCarType";

const CarTypeFilter = (props) => {
    const selectProps = {
        inputProps: { name: "carTypeId" },
        value: props.values.carTypeId,
        setValue: props.setFilter,
    };
    return <BaseCarTypeFilter {...props} selectProps={selectProps} />;
};

export default CarTypeFilter;
